import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import { Field} from 'redux-form';
import FormTextInput from '../../FormComponents/formTextInput';

class County extends Base{
    constructor(props){
        super(props);
    }

    renderOnCard() {
        let {renderType, data, showLabel=false,preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }
    renderOnGrid() {
        let {renderType, data, showLabel=false,preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }
    renderOnDetail() {
        let {renderType, data, showLabel=false, preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }

    renderOnCreate() {
        return (
            <Field
                component={FormTextInput}
                wrapperClass=""
                className=""
                name={this.props.data[0].Name}
                formGroup="formGroup colFlex bottomSpace"
                type="text"
                isDisabled={this.props.data[0].IsNonEditable}
                placeholder={!this.props.data[0].IsNonEditable ? this.props.placeholder :""}
                maxLength={this.props.data[0].MaxLength!=0 &&this.props.data[0].MaxLength}

            />
        )
    }
}

export default County;